module.exports = __webpack_public_path__ + "media/images/background-photo-1-1@1x-0f40377041b0419e2fceda6453eed448.png";